module.exports = __webpack_public_path__ + "static/media/tire_rotation.88e1b59f.svg";